<app-sub-menu [subMenus]="subMenus"></app-sub-menu>

<div class="container-fluid bg-box">
  <button class="btn btn-sm btn-success mb-2 text-uppercase" type="button" data-bs-toggle="collapse"
    data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample" [disabled]="false">
    <i class="fa fa-search"></i>
    Buscar usuarios
  </button>
  <div class="collapse" id="collapseExample">
    <div class="card card-body">
      <app-form-search-user [btnBuscarEnabled]="btnBuscarEnabled" (emitSearch)="searchUser($event)"></app-form-search-user>
    </div>
  </div>
</div>

<div class="container-fluid bg-box">
  <div class="row mb-3">
    <div class="col">
      <h3>Listado de usuarios</h3>
    </div>
  </div>
  <hr />
  <div class="row">
    <div class="col-12">
      <div class="table-responsive">
        <table id="tableUsuarios" datatable="ng" class="table table-bordered text-center"
          [class.table-striped]="collection">
          <thead>
            <tr>
              <th>Estatus</th>
              <th>No. Empleado</th>
              <th>Nombre</th>
              <th>Correo</th>
              <th>Rol</th>
              <th>Region</th>
              <th>Fecha alta</th>
              <th>Fecha mod.</th>
              <th>Dar de baja</th>
              <th>Negocio/Region</th>
            </tr>
          </thead>
          <tbody *ngIf="collection; else loading">
            <tr *ngFor="let item of collection">
              <td>
                <div class="badges text-center">
                  <span [ngStyle]="{ 'background-color': item.EstatusColor }" class="badges--publicado">
                    {{ item.EstatusDescripcion }}
                  </span>
                </div>
              </td>
              <td>{{ item.IdEmpleado }}</td>
              <td>{{ item.Nombre }}</td>
              <td>{{ item.Correo }}</td>
              <td>{{ item.Roles[0].Descripcion }}</td>
              <td>{{ item.IdRegion }}</td>
              <td>{{ datetimeToDateFormat(item.FechaAlta) }}</td>
              <td>{{ datetimeToDateFormat(item.FechaMod) }}</td>
              <td class="text-center">
                <button [disabled]="item.IdEstatus == 2 || item.Roles[0].IdRol == 6" type="button" class="btn btn-danger btn-sm rounded-circle"
                  title="Dar de baja al usuario" (click)="bajaUsuario(item.IdEmpleado)">
                  <i class="fa fa-minus"></i>
                </button>
              </td>
              <td class="text-center">
                <button type="button" class="btn btn-success btn-sm rounded-circle" title="Relacionar con región"
                  (click)="addUsuarioRegion(item.IdEmpleado, item.Nombre)">
                  <i class="fa fa-id-card" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
            <tr *ngIf="!loadRows">
              <td colspan="12" class="text-center">
                <button class="btn btn-lg btn-outline-dark text-uppercase w-100" (click)="loadUsers()">
                  Cargar mas usuarios
                </button>
              </td>
            </tr>
            <tr *ngIf="loadRows">
              <td colspan="10" class="text-center">
                <p>CARGANDO...</p>
              </td>
            </tr>
          </tbody>
          <ng-template #loading>
            <tbody>
              <tr *ngFor="let item of [].constructor(10)">
                <td colspan="4">
                  <div class="w-100 p-3 rounded border border-white skeleton"></div>
                </td>
                <td colspan="3">
                  <div class="w-100 p-3 rounded border border-white skeleton"></div>
                </td>
                <td colspan="3">
                  <div class="w-100 p-3 rounded border border-white skeleton"></div>
                </td>
              </tr>
            </tbody>
          </ng-template>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modalRelacionRegion" tabindex="-1" role="dialog" aria-labelledby="modalEditRevisionLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <app-form-config-user [negocios]="negocios" [roles]="catalogoRoles" [usuario]="usuarioConfig" />
  </div>
</div>